module.exports = __webpack_public_path__ + "static/media/introduce_p6@2x.7001b829.png";